import { queryOptions } from '@tanstack/vue-query';
import { PriorityQueryKey } from '@/modules/common/enums/query-key.enum.ts';
import { TimezoneApi } from '@/modules/counterparty/api/timezone.api.ts';

export class TimezoneQueryOptions {
  static BASE_KEY = 'timezone';

  static getList(signal?: AbortSignal) {
    return queryOptions({
      queryKey: [PriorityQueryKey.Secondary, TimezoneQueryOptions.BASE_KEY],
      queryFn: (meta) => TimezoneApi.getList(signal ?? meta.signal),
    });
  }
}
